// import axios from 'axios';
// import React, { useEffect, useState } from 'react'
// import { toast } from 'react-toastify';
// import { baseUrl } from '../../../Config/baseUrl';
// import { useFormik } from 'formik';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { Button } from '@mui/material';
// import ViewMetaDetails from '../ViewDetails';

// const AddMetaDetails = () => {
//     const { id } = useParams()
//     const { state } = useLocation()
//     const { type } = useParams();
//     const [data, setData] = useState();
//     const navegate = useNavigate();
//     const getAddMeta = () => {
//         axios
//             .get(`${baseUrl}/blog/meta-api/?metamodel_id=${state} &page_title=${id}`, {
//                 headers: {
//                     Authorization: `Token ${localStorage.getItem("token")}`,
//                     "Access-Control-Allow-Origin": "*",
//                 },
//             })
//             .then((res) => {
//                 console.log("RESPONSE ==== : ", res.data);
//                 setData(res.data?.data[0]);
//                 // handleEdit(res.data?.news_details);
//             })
//             .catch((err) => {
//                 console.log("ERROR: ====", err);
//                 toast.error(err.message);
//             });
//     };

//     useEffect(() => {
//         state && getAddMeta();
//     }, [state])
//     console.log(data);

//     const formik = useFormik({
//         initialValues: {
//             page_title: id,
//             meta_title: data?.meta_title || "",
//             meta_tag: data?.meta_tag || "",
//             keyword: data?.keyword || "",
//             meta_description: data?.meta_description || "",
//             canonical: data?.canonical || "",
//             og_title: data?.og_title || "",
//             og_image: null,
//             og_discription: data?.og_discription || "",
//             og_type: data?.og_type || "",
//             og_sitename: data?.og_sitename || "",
//             og_url: data?.og_url || "",
//             twitter_card: data?.twitter_card || "",
//             twitter_description: data?.twitter_description || "",
//             twitter_image: null,
//             alternate: data?.alternate || "",
//             robots_txt: data?.robots_txt || "",
//             schema: data?.schema || " ",
//             og_locale: data?.og_locale || "",
//             fb_admin: data?.fb_admin || "",
//             twitter_title: data?.twitter_title || "",
//             twitter_site: data?.twitter_site || " ",
//             url: data?.url || " ",
//             lang: data?.lang || " ",
//         },
//         enableReinitialize: true,
//         onSubmit: (values) => {
//             const reqbody = new FormData();
//             reqbody.append("store", localStorage.getItem("store_id"));
//             reqbody.append("meta_title", values.meta_title);
//             reqbody.append("meta_tag", values.meta_tag);
//             reqbody.append("keyword", values.keyword);
//             reqbody.append("meta_description", values.meta_description);
//             reqbody.append("canonical", values.canonical);
//             reqbody.append("og_title", values.og_title);
//             if (values.og_image) reqbody.append("og_image", values.og_image);
//             reqbody.append("og_discription", values.og_discription);
//             reqbody.append("og_type", values.og_type);
//             reqbody.append("og_sitename", values.og_sitename);
//             reqbody.append("og_url", values.og_url);
//             reqbody.append("twitter_card", values.twitter_card);
//             reqbody.append("twitter_description", values.twitter_description);
//             if (values.twitter_image) reqbody.append("twitter_image", values.twitter_image);
//             reqbody.append("alternate", values.alternate);
//             reqbody.append("robots_txt", values.robots_txt)
//             reqbody.append("schema", values.schema)
//             reqbody.append("og_locale", values.og_locale);
//             reqbody.append("fb_admin", values.fb_admin);
//             reqbody.append("twitter_title", values.twitter_title);
//             reqbody.append("twitter_site", values.twitter_site)
//             reqbody.append("url", values.url)
//             reqbody.append("lang", values.lang)

//             reqbody.append("page_id", id)
//             type === "update" && reqbody.append("metamodel_id", state)
//             type === "add"
//                 ? axios
//                     .post(
//                         `${baseUrl}/blog/meta-api/`,
//                         { ...values, store: localStorage.getItem("store_id") },
//                         {
//                             headers: {
//                                 Authorization: `Token ${localStorage.getItem("token")}`,
//                                 "Content-Type": "multipart/form-data",
//                             },
//                         }
//                     )
//                     .then((response) => {
//                         toast.success(response.data.message);
//                         navegate(`/metadetails/${id}`);
//                     })
//                     .catch((error) => {
//                         toast.error("Error adding blog:", error);
//                     })
//                 : axios
//                     .patch(`${baseUrl}/blog/meta-api/`, reqbody, {
//                         headers: {
//                             "Content-Type": "multipart/form-data",
//                             Authorization: `Token ${localStorage.getItem("token")}`,
//                         },
//                     })
//                     .then((response) => {
//                         toast.success(response.data.message);
//                         navegate(`/metadetails/${id}`);
//                     })
//                     .catch((error) => {
//                         toast.error("Error updating meta:", error);
//                     });
//         },
//     });

//     return (
//         <div>
//             {type !== "view" ? <div className="flex flex-col w-full justify-cEnter lg:w-3/5">
//                 <div className="mt-5 bg-white shadow-lg">
//                     <form onSubmit={formik.handleSubmit}>
//                         <div className="p-2 border-gray-300 rounded-md ">
//                             <div className="flex flex-col gap-5">

//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Meta_title</p>
//                                         <input
//                                             id="meta_title"
//                                             placeholder="Enter title"
//                                             value={formik.values.meta_title}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Meta_tag"</p>
//                                         <input
//                                             id="meta_tag"
//                                             placeholder="Enter Website Name"
//                                             value={formik.values.meta_tag}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}

//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">meta_keyword</p>
//                                         <input
//                                             id="keyword"
//                                             value={formik.values.keyword}
//                                             placeholder='Enter Some word about Website'
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Meta_Description</p>
//                                         <input
//                                             id="meta_description"
//                                             placeholder='Enter about Your Website'
//                                             value={formik.values.meta_description}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">canonical</p>
//                                         <input
//                                             id="canonical"
//                                             placeholder="Enter your wesite url"
//                                             value={formik.values.canonical}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Og_Title</p>
//                                         <input
//                                             id="og_title"
//                                             value={formik.values.og_title}
//                                             placeholder='Enter some word about Website'
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">og_locale</p>
//                                         <input
//                                             id="og_locale"
//                                             placeholder='en_US'
//                                             value={formik.values.og_locale}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Og_Image</p>
//                                         <input
//                                             id="og_image"
//                                             type='file'

//                                             placeholder="image"

//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={(event) =>
//                                                 formik.setFieldValue("og_image", event.target.files[0])
//                                             }
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Og_Discription</p>
//                                         <input
//                                             id="og_discription"
//                                             placeholder="Enter Og descrition is somthing  ..."
//                                             value={formik.values.og_discription}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}

//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Og Type</p>
//                                         <input
//                                             id="og_type"
//                                             value={formik.values.og_type}
//                                             placeholder='website'
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Og Sitename</p>
//                                         <input
//                                             id="og_sitename"
//                                             placeholder='website Name'
//                                             value={formik.values.og_sitename}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold"> og_url</p>
//                                         <input
//                                             id="og_url"
//                                             placeholder=' Enter your site url'
//                                             value={formik.values.og_url}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">fb_admin</p>
//                                         <input
//                                             id="fb_admin"
//                                             placeholder='Enter your website name '
//                                             value={formik.values.fb_admin}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Og_twitter</p>
//                                         <input
//                                             id="twitter_title"
//                                             placeholder='Enter website url'
//                                             value={formik.values.twitter_title}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">twitter_card</p>
//                                         <input
//                                             id="twitter_card"
//                                             placeholder='about website summary'
//                                             value={formik.values.twitter_card}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">twitter_description</p>
//                                         <input
//                                             id="twitter_description"
//                                             placeholder='this is my website at work on may types of web development'
//                                             value={formik.values.twitter_description}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">twitter_site</p>
//                                         <input
//                                             id="twitter_site"
//                                             value={formik.values.twitter_site}
//                                             placeholder="Enter your website url"
//                                             className="w-full p-2 px-4 m-1 placeholder-gray-500 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Url</p>
//                                         <input
//                                             id="url"

//                                             value={formik.values.url}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                             placeholder='https//yourwebsite.com/'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">twitter_image</p>
//                                         <input
//                                             id="twitter_image"
//                                             type='file'
//                                             placeholder='Enter Image'
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={(event) =>
//                                                 formik.setFieldValue("twitter_image", event.target.files[0])
//                                             }
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">lang</p>
//                                         <input
//                                             id="lang"
//                                             placeholder='en_US'
//                                             value={formik.values.lang}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Alternate</p>
//                                         <input
//                                             id="alternate"
//                                             placeholder='https//yourwebsite.com/'
//                                             value={formik.values.alternate}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">Robots</p>
//                                         <input
//                                             id="robots_txt"
//                                             value={formik.values.robots_txt}
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                             placeholder='index,follow'
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <div>
//                                         <p className="p-1 text-sm font-semibold">schema</p>
//                                         <input
//                                             id="schema"
//                                             value={formik.values.schema}
//                                             placeholder='about business'
//                                             className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                                             onChange={formik.handleChange}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="w-full pl-3 ">
//                                     <Button type="submit" variant="contained">
//                                         Add
//                                     </Button>
//                                 </div>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//                 : <ViewMetaDetails data={data} />}
//         </div>
//     )
// }

// export default AddMetaDetails

import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import { BsStars } from "react-icons/bs";
import { baseUrl } from "../../../Config/baseUrl";
import ViewMetaDetails from "../ViewDetails";

/* ------------------------------------------------------------------ */
/* Gemini config                                                       */
/* CRA  -> REACT_APP_GEMINI_API_KEY   (process.env.REACT_APP_...)      */
/* Vite -> VITE_GEMINI_API_KEY        (import.meta.env.VITE_...)       */
/* NOTE: a key used in the browser is visible to anyone. For production */
/* proxy this call through your Django backend.                        */
/* ------------------------------------------------------------------ */
const GEMINI_API_KEY = "AQ.Ab8RN6JoSqA6UGkjwLrsRqbro8M9b98VIbjmbrvSZix6KaRIzw";
const GEMINI_MODEL = "gemini-3-flash-preview";

const AI_KEYS = [
  "meta_title",
  "meta_tag",
  "keyword",
  "meta_description",
  "og_title",
  "og_discription",
  "og_type",
  "og_sitename",
  "og_locale",
  "twitter_card",
  "twitter_title",
  "twitter_description",
  "robots_txt",
  "schema",
  "lang",
];

const URL_KEYS = ["url", "canonical", "og_url", "alternate"];

const TEXT_KEYS = [
  "meta_title",
  "meta_tag",
  "keyword",
  "meta_description",
  "canonical",
  "og_title",
  "og_discription",
  "og_type",
  "og_sitename",
  "og_url",
  "og_locale",
  "fb_admin",
  "twitter_card",
  "twitter_title",
  "twitter_description",
  "twitter_site",
  "alternate",
  "robots_txt",
  "schema",
  "url",
  "lang",
];

const generateMetaWithGemini = async ({ pageName, brief, siteUrl, lang }) => {
  const prompt = `You are an SEO specialist. Write meta tags for the web page "${pageName}".

Page / business description:
${brief}
${siteUrl ? `Website URL: ${siteUrl}` : ""}
Language code: ${lang || "en"}

Rules:
- meta_title: max 60 characters, include the main keyword.
- meta_description: 140-160 characters, clear and click-worthy.
- meta_tag: the website / brand name.
- keyword: 6-10 comma-separated keywords.
- og_title: max 70 characters. og_discription: max 200 characters.
- og_type: "website" unless an article fits better. og_sitename: the brand name.
- og_locale: like en_US. lang: like en.
- twitter_card: "summary_large_image". twitter_title: max 70 characters. twitter_description: max 200 characters.
- robots_txt: like "index,follow".
- schema: valid JSON-LD (WebPage or Organization) as a single JSON string.
Return only JSON.`;

  const str = { type: "STRING" };
  const res = await fetch(
    `https://generativelanguage.googleapis.com/v1beta/models/${GEMINI_MODEL}:generateContent`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-goog-api-key": GEMINI_API_KEY,
      },
      body: JSON.stringify({
        contents: [{ parts: [{ text: prompt }] }],
        generationConfig: {
          responseMimeType: "application/json",
          responseSchema: {
            type: "OBJECT",
            properties: Object.fromEntries(AI_KEYS.map((k) => [k, str])),
            required: AI_KEYS,
          },
        },
      }),
    },
  );

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(
      err?.error?.message || `Gemini request failed (${res.status})`,
    );
  }
  const json = await res.json();
  const text = json?.candidates?.[0]?.content?.parts?.[0]?.text;
  if (!text) throw new Error("Gemini returned an empty response");
  return JSON.parse(text);
};

/* ------------------------------------------------------------------ */
/* Small UI pieces (defined outside so inputs never remount/lose focus) */
/* ------------------------------------------------------------------ */
const inputCls =
  "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

const Section = ({ title, hint, children }) => (
  <section className="rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
    <div className="mb-4 border-b border-gray-100 pb-3">
      <h2 className="text-base font-semibold text-gray-800">{title}</h2>
      {hint && <p className="mt-0.5 text-xs text-gray-500">{hint}</p>}
    </div>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">{children}</div>
  </section>
);

const Field = ({
  formik,
  name,
  label,
  placeholder,
  hint,
  multiline,
  rows = 3,
  max,
  wide,
}) => {
  const value = formik.values[name] ?? "";
  const over = max && value.length > max;
  const Tag = multiline ? "textarea" : "input";
  return (
    <div className={wide || multiline ? "md:col-span-2" : ""}>
      <div className="mb-1 flex items-center justify-between">
        <label htmlFor={name} className="text-sm font-medium text-gray-700">
          {label}
        </label>
        {max && (
          <span
            className={`text-xs ${over ? "text-red-500" : "text-gray-400"}`}
          >
            {value.length}/{max}
          </span>
        )}
      </div>
      <Tag
        id={name}
        name={name}
        rows={multiline ? rows : undefined}
        placeholder={placeholder}
        value={value}
        onChange={formik.handleChange}
        className={`${inputCls} ${multiline ? "resize-y" : ""}`}
      />
      {hint && <p className="mt-1 text-xs text-gray-400">{hint}</p>}
    </div>
  );
};

const FileField = ({ formik, name, label, existing }) => {
  const file = formik.values[name];
  return (
    <div>
      <label
        htmlFor={name}
        className="mb-1 block text-sm font-medium text-gray-700"
      >
        {label}
      </label>
      <input
        id={name}
        name={name}
        type="file"
        accept="image/*"
        onChange={(e) => formik.setFieldValue(name, e.target.files[0] || null)}
        className={`${inputCls} file:mr-3 file:rounded file:border-0 file:bg-gray-100 file:px-3 file:py-1 file:text-sm file:text-gray-700`}
      />
      {file ? (
        <p className="mt-1 truncate text-xs text-gray-500">
          Selected: {file.name}
        </p>
      ) : typeof existing === "string" && existing ? (
        <a
          href={existing}
          target="_blank"
          rel="noreferrer"
          className="mt-2 inline-block"
        >
          <img
            src={existing}
            alt={label}
            className="h-16 rounded border border-gray-200 object-cover"
          />
        </a>
      ) : null}
    </div>
  );
};

/* ------------------------------------------------------------------ */

const AddMetaDetails = () => {
  const { id, type } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState();
  const [submitting, setSubmitting] = useState(false);

  // AI generation
  const [aiBrief, setAiBrief] = useState("");
  const [aiSiteUrl, setAiSiteUrl] = useState("");
  const [onlyEmpty, setOnlyEmpty] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);

  const getAddMeta = () => {
    axios
      .get(`${baseUrl}/blog/meta-api/?metamodel_id=${state}&page_title=${id}`, {
        headers: { Authorization: `Token ${localStorage.getItem("token")}` },
      })
      .then((res) => setData(res.data?.data?.[0]))
      .catch((err) => toast.error(err.message));
  };

  useEffect(() => {
    state && getAddMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const formik = useFormik({
    initialValues: {
      page_title: id,
      meta_title: data?.meta_title || "",
      meta_tag: data?.meta_tag || "",
      keyword: data?.keyword || "",
      meta_description: data?.meta_description || "",
      canonical: data?.canonical || "",
      og_title: data?.og_title || "",
      og_image: null,
      og_discription: data?.og_discription || "",
      og_type: data?.og_type || "",
      og_sitename: data?.og_sitename || "",
      og_url: data?.og_url || "",
      og_locale: data?.og_locale || "",
      fb_admin: data?.fb_admin || "",
      twitter_card: data?.twitter_card || "",
      twitter_title: data?.twitter_title || "",
      twitter_description: data?.twitter_description || "",
      twitter_site: data?.twitter_site?.trim() || "",
      twitter_image: null,
      alternate: data?.alternate || "",
      robots_txt: data?.robots_txt || "",
      schema: data?.schema?.trim() || "",
      url: data?.url?.trim() || "",
      lang: data?.lang?.trim() || "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const reqbody = new FormData();
      reqbody.append("store", localStorage.getItem("store_id"));
      reqbody.append("page_title", id);
      reqbody.append("page_id", id);
      TEXT_KEYS.forEach((k) => reqbody.append(k, values[k] ?? ""));
      if (values.og_image) reqbody.append("og_image", values.og_image);
      if (values.twitter_image)
        reqbody.append("twitter_image", values.twitter_image);
      if (type === "update") reqbody.append("metamodel_id", state);

      const request = {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      };

      setSubmitting(true);
      (type === "add"
        ? axios.post(`${baseUrl}/blog/meta-api/`, reqbody, request)
        : axios.patch(`${baseUrl}/blog/meta-api/`, reqbody, request)
      )
        .then((response) => {
          toast.success(response.data.message);
          navigate(`/metadetails/${id}`);
        })
        .catch((error) => {
          toast.error(
            error.response?.data?.message ||
              `Error ${type === "add" ? "adding" : "updating"} meta`,
          );
        })
        .finally(() => setSubmitting(false));
    },
  });

  const handleGenerate = async () => {
    if (!GEMINI_API_KEY) {
      toast.error("Gemini API key is missing. Set REACT_APP_GEMINI_API_KEY.");
      return;
    }
    if (!aiBrief.trim()) {
      toast.error("Describe the page or business first.");
      return;
    }
    setAiLoading(true);
    try {
      const gen = await generateMetaWithGemini({
        pageName: id,
        brief: aiBrief.trim(),
        siteUrl: aiSiteUrl.trim(),
        lang: formik.values.lang,
      });

      const next = { ...formik.values };
      const canWrite = (k) =>
        !onlyEmpty || !String(formik.values[k] || "").trim();

      AI_KEYS.forEach((k) => {
        let v = gen?.[k];
        if (v && typeof v === "object") v = JSON.stringify(v, null, 2);
        if (typeof v !== "string" || !v.trim() || !canWrite(k)) return;
        next[k] = v.trim();
      });

      if (aiSiteUrl.trim()) {
        URL_KEYS.forEach((k) => canWrite(k) && (next[k] = aiSiteUrl.trim()));
      }

      formik.setValues(next);
      toast.success("Meta generated. Review the fields, then save.");
    } catch (err) {
      toast.error(err.message || "Could not generate meta");
    } finally {
      setAiLoading(false);
    }
  };

  if (type === "view") return <ViewMetaDetails data={data} />;

  const f = { formik };

  return (
    <div className="w-full max-w-4xl py-5">
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-5">
        {/* AI generator */}
        <section className="rounded-lg border border-indigo-200 bg-indigo-50/60 p-5">
          <div className="mb-3 flex items-center gap-2">
            <BsStars className="text-indigo-600" size={18} />
            <h2 className="text-base font-semibold text-gray-800">
              Generate with AI
            </h2>
          </div>
          <p className="mb-3 text-xs text-gray-600">
            Describe the page and Gemini will fill the meta, Open Graph and
            Twitter fields below. You can edit everything before saving.
          </p>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <div className="md:col-span-2">
              <label
                htmlFor="ai_brief"
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                About this page
              </label>
              <textarea
                id="ai_brief"
                rows={3}
                value={aiBrief}
                onChange={(e) => setAiBrief(e.target.value)}
                placeholder="e.g. Home page of a Delhi-based web development agency building React and Django apps for small businesses"
                className={`${inputCls} resize-y`}
              />
            </div>
            <div>
              <label
                htmlFor="ai_site_url"
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Website URL (optional)
              </label>
              <input
                id="ai_site_url"
                value={aiSiteUrl}
                onChange={(e) => setAiSiteUrl(e.target.value)}
                placeholder="https://yourwebsite.com/"
                className={inputCls}
              />
            </div>
            <label className="flex items-end gap-2 pb-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={onlyEmpty}
                onChange={(e) => setOnlyEmpty(e.target.checked)}
                className="h-4 w-4"
              />
              Only fill empty fields
            </label>
          </div>
          <div className="mt-4">
            <Button
              variant="contained"
              onClick={handleGenerate}
              disabled={aiLoading}
              startIcon={
                aiLoading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <BsStars />
                )
              }
            >
              {aiLoading ? "Generating..." : "Generate meta"}
            </Button>
          </div>
        </section>

        <Section title="Basic SEO" hint="What search engines show in results.">
          <Field
            {...f}
            name="meta_title"
            label="Meta title"
            placeholder="Page title shown in search results"
            max={60}
            wide
          />
          <Field
            {...f}
            name="meta_tag"
            label="Meta tag (site name)"
            placeholder="Your website name"
          />
          <Field
            {...f}
            name="keyword"
            label="Meta keywords"
            placeholder="react, web development, delhi"
            hint="Comma separated"
          />
          <Field
            {...f}
            name="meta_description"
            label="Meta description"
            placeholder="A short summary of this page"
            multiline
            rows={3}
            max={160}
          />
          <Field
            {...f}
            name="canonical"
            label="Canonical URL"
            placeholder="https://yourwebsite.com/"
          />
          <Field
            {...f}
            name="url"
            label="URL"
            placeholder="https://yourwebsite.com/"
          />
          <Field
            {...f}
            name="alternate"
            label="Alternate URL"
            placeholder="https://yourwebsite.com/"
          />
          <Field {...f} name="lang" label="Language" placeholder="en" />
        </Section>

        <Section
          title="Open Graph"
          hint="How the page looks when shared on Facebook, LinkedIn and WhatsApp."
        >
          <Field
            {...f}
            name="og_title"
            label="OG title"
            placeholder="Title for social sharing"
          />
          <Field
            {...f}
            name="og_sitename"
            label="OG site name"
            placeholder="Your website name"
          />
          <Field
            {...f}
            name="og_discription"
            label="OG description"
            placeholder="Short description for social sharing"
            multiline
            rows={3}
            max={200}
          />
          <Field {...f} name="og_type" label="OG type" placeholder="website" />
          <Field
            {...f}
            name="og_locale"
            label="OG locale"
            placeholder="en_US"
          />
          <Field
            {...f}
            name="og_url"
            label="OG URL"
            placeholder="https://yourwebsite.com/"
          />
          <Field
            {...f}
            name="fb_admin"
            label="Facebook admin ID"
            placeholder="Facebook admin or app ID"
          />
          <FileField
            {...f}
            name="og_image"
            label="OG image"
            existing={data?.og_image}
          />
        </Section>

        <Section
          title="Twitter / X"
          hint="How the page looks when shared on X."
        >
          <Field
            {...f}
            name="twitter_title"
            label="Twitter title"
            placeholder="Title for X"
          />
          <Field
            {...f}
            name="twitter_card"
            label="Twitter card"
            placeholder="summary_large_image"
          />
          <Field
            {...f}
            name="twitter_description"
            label="Twitter description"
            placeholder="Short description for X"
            multiline
            rows={3}
            max={200}
          />
          <Field
            {...f}
            name="twitter_site"
            label="Twitter site"
            placeholder="@yourhandle"
          />
          <FileField
            {...f}
            name="twitter_image"
            label="Twitter image"
            existing={data?.twitter_image}
          />
        </Section>

        <Section title="Advanced" hint="Crawler rules and structured data.">
          <Field
            {...f}
            name="robots_txt"
            label="Robots"
            placeholder="index,follow"
          />
          <Field
            {...f}
            name="schema"
            label="Schema (JSON-LD)"
            placeholder='{"@context":"https://schema.org","@type":"WebPage"}'
            multiline
            rows={6}
          />
        </Section>

        <div className="flex items-center gap-3">
          <Button
            type="submit"
            variant="contained"
            disabled={submitting || aiLoading}
          >
            {submitting ? "Saving..." : type === "add" ? "Add" : "Update"}
          </Button>
          <Button type="button" variant="outlined" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddMetaDetails;
